import { TeamConfigurationComponent } from '@devd-client/devd/components';

export const TeamConfiguration = () => {
  return <TeamConfigurationComponent />;
};

export default TeamConfiguration;
